module.exports = __webpack_public_path__ + "static/img/Straight_Flush.7823ef8.svg";